<template>
    <user-center-slot>
        <user-center-container-slot>
            <!-- 左侧菜单栏 -->
            <user-center-menu />
            <!-- 右侧内容 -->
            <user-center-content-slot>
                <user-center-content-title title="团队菜单" />
                <div class="user-center__team-row">
                    <div class="user-center__team-portrait">
                        <div>
                            <img v-if="pictureID"
                                :src="pictureID"
                                class="user-center__team-pic" />
                            <i v-else
                                class="iconfont icon-tuandui user-center__team-icon--default"></i>
                        </div>
                        <div class="user-center__team-summary--left">
                            <span v-if="!noTeam && !isTeamLeader"
                                class="user-center__team-summary-txt">
                                您加入了 <span class="user-center__team-summary-txt--inner">{{ teamUserInfo.teamName }}</span>战队
                            </span>
                            <span v-if="noTeam && !isTeamLeader"
                                class="user-center__team-summary-txt">
                                您还未加入任何队伍
                            </span>
                            <span v-if="isTeamLeader"
                                class="user-center__team-summary-txt">
                                您是<span class="user-center__team-summary-txt--inner">{{ teamUserInfo.teamName }}</span>队长
                            </span>
                        </div>
                        <div v-if="isTeamLeader"
                            class="user-center__team-summary--right">
                            贡献值：<span class="user-center__team-summary-txt--inner user-center__team-summary-txt--contributed">{{ teamUserInfo.donate }}</span>
                        </div>
                        <div v-if="!noTeam && !isTeamLeader"
                            class="user-center__team-summary--right">
                            贡献值：<span class="user-center__team-summary-txt--inner user-center__team-summary-txt--contributed">{{ teamUserInfo.donate }}</span>
                        </div>
                    </div>
                </div>

                <div class="user-center__team-row--secondary">
                    <span>团队信息</span>
                </div>

                <div class="user-center__team-operation"
                    v-if="noTeam && !isTeamLeader">
                    <a href="javascript:void(0);"
                        @click="openCreateTeam"
                        class="user-center__team-operation-button">创建团队</a>
                    <a href="javascript:void(0);"
                        @click="openJoinTeam"
                        class="user-center__team-operation-button">加入团队</a>
                </div>

                <div class="user-center__team-list">
                    <xui-table v-loading="tableLoading"
                        :data="latestData"
                        :stripe="false"
                        :show-header="true"
                        style="width: 100%">
                        <!-- prop="${creationDate.format("yyyy/MM/dd hh:mm:ss")}" -->
                        <xui-table-column prop="teamName"
                            show-overflow-tooltip
                            label="团队名称"
                            align="left"> </xui-table-column>

                        <xui-table-column prop="teamUser"
                            show-overflow-tooltip
                            label="用户昵称"> </xui-table-column>

                        <xui-table-column prop="donate"
                            show-overflow-tooltip
                            width="100"
                            label="贡献值"> </xui-table-column>

                        <xui-table-column label="操作">
                            <template slot-scope="scope">
                                <xui-button v-if="isTeamLeader && !(teamUserInfo.teamUser === scope.row.teamUser)"
                                    type="text"
                                    @click="operations(scope.row, 'handOver')">转让队长</xui-button>
                                <xui-button v-if="isTeamLeader && !(teamUserInfo.teamUser === scope.row.teamUser)"
                                    type="text"
                                    @click="operations(scope.row, 'kickOut')">踢出成员</xui-button>
                                <xui-button v-if="!isTeamLeader && teamUserInfo.teamUser === scope.row.teamUser"
                                    type="text"
                                    @click="operations(scope.row, 'quit')">退出团队</xui-button>
                            </template>
                        </xui-table-column>
                    </xui-table>
                </div>

                <!-- <div class="user-center__team-row--secondary" v-if="(!isTeamLeader && msgList.length) || (isTeamLeader && msgList.length)"> -->
                <div class="user-center__team-row--secondary">
                    <span>我的消息</span>
                </div>
                <div v-if="!isTeamLeader && msgList.length">
                    <div v-for="(item, index) in msgList"
                        :key="index"
                        class="user-center__person-msg-list">
                        <div v-if="!item.isAdmin && !item.status"
                            class="user-center__person-msg-item">
                            <div class="user-center__person-msg-txt--top">
                                <div>
                                    <span class="user-center__person-msg-tag">系统通知</span><span class="user-center__person-team-type">对战队</span><span
                                        class="user-center__person-team-name">{{ item.teamName }}</span>
                                        <span v-if="item.type === 1" style="padding-left: 15px" class="user-center__person-team-name">申请加入</span>
                                        <span v-if="item.type === 2" style="padding-left: 15px" class="user-center__person-team-name">申请退出</span>
                                </div>
                                <div class="user-center__person-approval">申请已提交，等待团长审核</div>
                            </div>
                            <div class="user-center__person-msg-txt--middle">
                                申请内容：
                                <div class="user-center__person-application">{{ item.content }}</div>
                            </div>
                            <div class="user-center__person-msg-txt--bottom">{{ item.creationDate }}</div>
                        </div>
                        <div v-if="item.isAdmin && !item.status"
                            class="user-center__person-msg-item">
                            <div class="user-center__person-msg-txt--top">
                                <div>
                                    <span class="user-center__person-msg-tag">系统通知</span><span class="user-center__person-team-type">对战队</span><span
                                        class="user-center__person-team-name">{{ item.teamName }}</span>
                                        <span v-if="item.type === 1" style="padding-left: 15px" class="user-center__person-team-name">申请加入</span>
                                        <span v-if="item.type === 2" style="padding-left: 15px" class="user-center__person-team-name">申请退出</span>
                                </div>
                                <div class="user-center__person-approval">申请团长已同意</div>
                            </div>
                            <div class="user-center__person-msg-txt--bottom">{{ item.creationDate }}</div>
                        </div>
                        <div v-if="item.isAdmin && item.status"
                            class="user-center__person-msg-item">
                            <div class="user-center__person-msg-txt--top">
                                <div>
                                    <span class="user-center__person-msg-tag">系统通知</span><span class="user-center__person-team-type">对战队</span><span
                                        class="user-center__person-team-name">{{ item.teamName }}</span>
                                        <span v-if="item.type === 1" style="padding-left: 15px" class="user-center__person-team-name">申请加入</span>
                                        <span v-if="item.type === 2" style="padding-left: 15px" class="user-center__person-team-name">申请退出</span>
                                </div>
                                <div class="user-center__person-approval">申请团长已拒绝</div>
                            </div>
                            <div class="user-center__person-msg-txt--bottom">{{ item.creationDate }}</div>
                        </div>
                    </div>
                </div>
                <div v-if="isTeamLeader && msgList.length">
                    <div v-for="(item, index) in msgList"
                        :key="index"
                        class="user-center__person-msg-list">
                        <div class="user-center__person-msg-item">
                            <div class="user-center__person-msg-txt--top">
                                <div v-if="item.type === 1">{{ item.teamUser }}于{{ item.creationDate }}向您提交战队申请</div>
                                <div v-if="item.type === 2">{{ item.teamUser }}于{{ item.creationDate }}向您提交退出战队申请</div>
                                <div v-if="item.type === 1">
                                    <a href="javascript: void(0);"
                                        @click="approve(item, 'y')"
                                        class="user-center__person-approval-button">同意</a>
                                    <a href="javascript: void(0);"
                                        @click="approve(item, 'n')"
                                        class="user-center__person-approval-button">拒绝</a>
                                </div>
                                <div v-if="item.type === 2">
                                    <a href="javascript: void(0);"
                                        @click="approveQuit(item, 'y')"
                                        class="user-center__person-approval-button">同意</a>
                                    <a href="javascript: void(0);"
                                        @click="approveQuit(item, 'n')"
                                        class="user-center__person-approval-button">拒绝</a>
                                </div>
                            </div>
                            <div class="user-center__person-msg-txt--middle">
                                申请内容：
                                <div class="user-center__person-application">{{ item.content }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="user-center__team-pager">
                    <xui-pagination :current-page.sync="page.currentPage"
                        :page-sizes="page.pageSizes"
                        :page-size="page.pageSize"
                        :total="page.totalPages"
                        layout="total, sizes, pager, jumper"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange1">
                    </xui-pagination>
                </div>
            </user-center-content-slot>
        </user-center-container-slot>
        <xui-dialog v-if="joinTeam"
            title="加入团队"
            class="joinTeamDialog"
            :close-on-click-modal="false"
            showcenter
            :visible.sync="joinTeam"
            width="30%"
            @close="joinTeam = false">
            <div style="font-size: 1rem; color: #aaaab3">温馨提示每个用户最多可同时申报3个战队，最先通过加入成功，加入满三个月后可退出</div>
            <xui-form ref="joinTeamForm"
                label-width="80px"
                style="padding: 0 20px; margin-top: 25px"
                :inline-message="true"
                label-position="top"
                :rules="rules"
                :model="commit"
                :cols="4">
                <xui-form-group>
                    <xui-form-item label="申请战队名称"
                        :cols="4"
                        prop="applyName">
                        <xui-select v-model="commit.applyName"
                            placeholder="请选择"
                            popper-class="xui-select-popper"
                            clearable
                            class="xui-select-class-0"
                            @change="changeTemplate">
                            <xui-option v-for="item in options1"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"> </xui-option>
                        </xui-select>
                    </xui-form-item>
                    <!-- <xui-form-item label="队长昵称" :cols="2" prop="applyLeader">
            <xui-input disabled="true" v-model="commit.applyLeader"></xui-input>
          </xui-form-item> -->
                </xui-form-group>
                <xui-form-group>
                    <xui-form-item label="申请内容"
                        :cols="4"
                        prop="applyMember">
                        <xui-input v-model.trim="commit.applyMember"
                            clearable
                            :rows="5"
                            type="textarea"
                            :maxlength="300"></xui-input>
                    </xui-form-item>
                </xui-form-group>
            </xui-form>
            <span slot="footer"
                class="dialog-footer"
                center>
                <xui-button type="primary"
                    size="bigger"
                    @click="joinTeam = false"> 取消</xui-button>
                <xui-button type="primary"
                    size="bigger"
                    @click="commitVerify('add')">提交审核</xui-button>
            </span>
        </xui-dialog>
        <xui-dialog v-if="quitTeam"
            title="退出团队"
            class="joinTeamDialog"
            :close-on-click-modal="false"
            showcenter
            :visible.sync="quitTeam"
            width="30%"
            @close="
        quitTeam = false;
        closeQuit();
      ">
            <xui-form ref="leaveTeamForm"
                label-width="80px"
                style="padding: 0 20px; margin-top: 25px"
                :inline-message="true"
                label-position="top"
                :rules="rules"
                :model="commit"
                :cols="4">
                <xui-form-group>
                    <xui-form-item label="退出原因"
                        :cols="4"
                        prop="content">
                        <xui-input v-model.trim="commit.content"
                            clearable
                            :rows="5"
                            type="textarea"
                            :maxlength="300"
                            placeholder="请输入退出原因"></xui-input>
                    </xui-form-item>
                </xui-form-group>
            </xui-form>
            <span slot="footer"
                class="dialog-footer"
                center>
                <xui-button type="primary"
                    size="bigger"
                    @click="
            quitTeam = false;
            closeQuit();
          ">
                    取消</xui-button>
                <xui-button type="primary"
                    size="bigger"
                    @click="commitQuitOpine()">提交审核</xui-button>
            </span>
        </xui-dialog>
        <xui-dialog v-if="createTeam"
            title="创建团队"
            class="joinTeamDialog"
            :close-on-click-modal="false"
            showcenter
            :visible.sync="createTeam"
            width="30%"
            @close="createTeam = false">
            <xui-form ref="createTeamForm"
                label-width="80px"
                label-position="top"
                :inline-message="true"
                :rules="rules"
                :model="commit"
                style="padding: 0 20px"
                :cols="4">
                <xui-form-group>
                    <xui-form-item prop="headPictureUrl"
                        style=" margin-left: 33%;margin-bottom:30px;height:171px;"
                        class="test"
                        :cols="2">
                        <div class="user-setting-avatar">
                            <div>
                                <div class="user-info-pic">
                                    <div class="avatar-uploader">
                                        <xui-upload class="xui-upload--text"
                                            :action="action"
                                            :headers="xCsrfToken"
                                            style="text-align: center;"
                                            :on-error="reportError"
                                            :limit="1"
                                            :before-upload="beforUploadZip"
                                            show-overflow-tooltip
                                            :on-exceed="handleExceed"
                                            :on-success="handlePreview"
                                            :with-credentials="true">
                                            <template v-if="commit.headPictureUrl">
                                                <img style="width:150px;height:150px;"
                                                    :src="this.$baseURL + 'vul/hsrc/vul/report/servlet/res/image?attachmentId=' + commit.headPictureUrl" />
                                            </template>
                                            <template v-else>
                                                <img style="width:150px;height:150px;"
                                                    src="../../../images/default-portrait.png" />
                                            </template>
                                            <span class="upload-headPicture-btn">上传头像</span>
                                            <input type="file"
                                                name="upload"
                                                class="xui-upload__input" />
                                        </xui-upload>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </xui-form-item>
                </xui-form-group>
                <div class="user-operations"><span>支持jpg、png、gif、jpeg格式图片，大小不超过2M</span></div>
                <xui-form-group>
                    <xui-form-item label="战队名称"
                        prop="name"
                        :cols="2">
                        <xui-input v-model.trim="commit.name"
                            :maxlength="20"></xui-input>
                    </xui-form-item>
                </xui-form-group>
            </xui-form>
            <span slot="footer"
                class="dialog-footer"
                center>
                <xui-button type="primary"
                    size="bigger"
                    @click="createTeam = false"> 取消</xui-button>
                <xui-button type="primary"
                    size="bigger"
                    @click="commitVerify('create')">确认创建</xui-button>
            </span>
        </xui-dialog>
        <!-- 登录提示弹框 -->
        <!-- <xui-dialog title="登录提醒" class="login-dialog" :close-on-click-modal="false" showcenter :visible.sync="isNotLogin" @close="handleClose" width="30%">
      <span>系统检测到您未登录或登录失效，请先登录</span>
      <span slot="footer" class="dialog-footer" center>
        <xui-button type="primary" size="bigger" @click="login">荣耀账号登录</xui-button>
      </span>
    </xui-dialog> -->
        <xui-dialog title=""
            class="warnning-wrap"
            :close-on-click-modal="false"
            showcenter
            :visible.sync="dialogVisible"
            :width="$store.state.isMobile ? '80%' : '30%'"
            :before-close="handleClose">
            <h3 :style="{ 'font-size': $store.state.isMobile ? '24px' : '16.5px' }">荣耀安全应急响应中心服务条款</h3>
            <div class="content-wrap"
                :style="{ 'font-size': $store.state.isMobile ? '22px' : '14px' }">
                <p>欢迎您使用荣耀安全应急响应中心（Honor Security Response Center）服务，本平台在特定场景下需收集您的如下信息:</p>
                <ul>
                    <li>真实姓名，身份证正反面照片及身份证号；</li>
                    <li>银行卡号，开户行信息，银行名称；</li>
                    <li>手机号码，邮寄地址；</li>
                    <li>昵称，头像，邮箱，主页；</li>
                    <li>QQ，微信，签名，团队；</li>
                    <li>IP地址；</li>
                    <li>为防止欺骗行为，荣耀需采集浏览器信息（类型、时区、插件、语言、字体、canvas图片渲染哈希值、webgl图片渲染哈希值）；</li>
                </ul>
                <p>上述数据将会传输并保存至位于中华人民共和国境内的服务器。</p>
                <span>点击“同意”，即表示您同意
                    <a :href="safetyURL"
                        target="_blank"
                        class="honor-security-user-protocol">荣耀安全应急响应中心用户协议</a>
                    ，并知悉
                    <a :href="privacyURL"
                        target="_blank"
                        class="honor-security-secret-statement">关于安全应急响应中心与隐私的声明</a>。</span>
            </div>
            <span slot="footer"
                center>
                <xui-button size="bigger"
                    @click="handleClose">取消</xui-button>
                <xui-button type="primary"
                    size="bigger"
                    @click="confirm">同意</xui-button>
            </span>
        </xui-dialog>
        <login :isNotLogin="isNotLogin"
            :isEffect="isEffect"></login>
    </user-center-slot>
</template>
<script>
import UserCenterMenu from '../../../components/pages/UserCenterMenu';
import UserCenterContainerSlot from '../../../components/pages/UserCenterContainerSlot';
import UserCenterSlot from '../../../components/pages/UserCenterSlot';
import UserCenterContentSlot from '../../../components/pages/UserCenterContentSlot';
import UserCenterContentTitle from '../../../components/pages/UserCenterContentTitle';
import router from '../../../router/index.js';
import { v4 } from 'uuid';
import { mapActions, mapState } from 'vuex';

export default {
  name: 'usercenterReport',
  components: {
    UserCenterMenu,
    UserCenterSlot,
    UserCenterContainerSlot,
    UserCenterContentSlot,
    UserCenterContentTitle
  },
  data() {
    return {
      safetyURL: '',
      privacyURL: '',
      pictureID: '',
      options1: [],
      rules: {
        name: [
          { required: true, message: '该项不能为空', trigger: 'change' },
          {
            validator: function (rule, value, callback) {
              if (/[<>&\\"']/g.test(value) == true) {
                callback(new Error('请不要输入特殊字符'));
              } else {
                callback();
              }
            },
            trigger: 'change'
          }
        ],
        applyName: [{ required: true, message: '该项不能为空', trigger: 'change' }],
        applyMember: [
          { required: true, message: '该项不能为空', trigger: 'change' },
          {
            validator: function (rule, value, callback) {
              if (/[<>&\\"']/g.test(value) == true) {
                callback(new Error('请不要输入特殊字符'));
              } else {
                callback();
              }
            },
            trigger: 'change'
          }
        ],
        headPictureUrl: [{ required: true, message: '该项不能为空', trigger: 'change' }],
        applyLeader: [{ required: true, message: '该项不能为空', trigger: 'change' }],
        content: [
          { required: true, message: '请输入退出原因', trigger: 'blur' },
          { max: 300, message: '退出原因超出长度限制' }
        ]
      },
      commit: {
        name: '',
        applyName: '',
        applyMember: '',
        applyLeader: '',
        headPictureUrl: null,
        content: '',
        teamId: ''
      },
      action: this.$baseURL + 'vul/hsrc/vul/report/servlet/uploadFile?ulType=VulUploadImg&dir=image',
      tableLoading: false,
      xCsrfToken: null,
      page: {
        pageSize: 5,
        pageSizes: [5, 10, 20],
        currentPage: 1,
        totalPages: 0
      },
      msgList: [],
      msgApproveList: [],
      teamUserInfo: {
        avatarId: '1034236027783413761445687763',
        creationDate: '2021-11-18 14:38:25',
        lastUpdateDate: '2021-11-18 14:38:25',
        status: 1,
        vulCount: 0,
        donate: 0,
        teamId: '1166840394275471361370876365',
        teamName: '',
        teamUser: '999990000000001',
        type: 1
      },
      dialogVisible: false,
      pageSize: 5,
      total: 0,
      isTeamLeader: false,
      noTeam: false,
      pageTotal: 0,
      status: '',
      statusData: [],
      createTeam: false,
      joinTeam: false,
      quitTeam: false,
      vulTitle: '',
      // 1，2，3 已受理
      // 4，5 已确认
      // 6，7，8，9 已支付
      // 10 已关闭
      latestData: []
    };
  },
  computed: {
    ...mapState(['isNotLogin', 'isEffect', 'unReadBbsCount', 'unReadMsgListCount'])
  },
  async mounted() {
    await this.getUserInfoAsync();
    await this.$setCsrf();
    this.getUserTeamInfo();
    const token = window.sessionStorage.getItem('x-csrf-token');
    this.xCsrfToken = { 'x-csrf-token': token };
    this.safetyURL = window.sessionStorage.getItem('safetyURL');
    this.privacyURL = window.sessionStorage.getItem('privacyURL');
  },
  methods: {
    ...mapActions(['getUserInfoAsync', 'adds']),
    // 上传附件之前
    beforUploadZip(file) {
      const testmsg = file.name.substring(file.name.lastIndexOf('.') + 1).toLowerCase();
      const extension = testmsg === 'jpg' || testmsg === 'jpeg' || testmsg === 'png' || testmsg === 'gif';
      const isList10M = file.size / 1024 / 1024 < 2;
      let bool = false;

      if (extension) {
        bool = true;
      } else {
        bool = false;
      }

      if (!extension) {
        this.$message.warning('上传文件只能是jpg,jpeg,png,gif格式');
      }
      if (!isList10M) {
        this.$message.warning('上传文件大小不能超过2M!');
      }
      return bool && isList10M;
    },
    // 确认个人签名
    confirm: function () {
      const s = new Promise((resolve, reject) => {
        this.$http
          .get('vul/hsrc/vul/report/services/autograph/save', { headers: { 'x-csrf-token': window.sessionStorage.getItem('x-csrf-token') } })
          .then(res => {
            // 保存成功后，放开修改
            if (res.status === 200) {
              this.dialogVisible = false;
            } else {
              this.dialogVisible = true;
            }
          })
          .catch(error => {
            console.log(error);
          });
      });
    },
    // 查询签名
    query() {
      return true;
      // return new Promise((resolve, reject) => {
      //   this.$http
      //     .get('vul/hsrc/vul/report/services/autograph/query', { headers: { 'x-csrf-token': window.sessionStorage.getItem('x-csrf-token') } })
      //     .then(res => {
      //       // 接口直接返回布尔值，false时为未签名，弹出签名窗
      //       if (!res.data) {
      //         this.dialogVisible = true;
      //       } else {
      //         this.dialogVisible = false;
      //         resolve(true);
      //         // 为true时，为签名验证已过，不需要签名
      //         // 已签名状态，就初始化验证码和奖励计划
      //       }
      //     })
      //     .catch(error => {
      //       console.log(error);
      //     });
      // });
    },
    operations(row, type) {
      if (type === 'handOver') {
        this.$confirm(`您即将要将${row.teamName}团队的队长转让给${row.teamUser}，是否确认？`, '请确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          closeOnClickModal: false,
          confirmButtonHighlight: true
        }).then(() => {
          this.$http
            .post(`vul/hsrc/vul/report/services/team/transferCaptain`, {
              teamUserId: row.teamUserId
            })
            .then(res => {
              // 可通过resolve发送给后端一些参数:resolve(res.data.xxx);
              if (res && res.data && res.data.status === 200) {
                this.page.currentPage = 1;
                this.$message({
                  message: `转让队长成功!`,
                  type: 'success'
                });
                this.getUserTeamInfo();
              } else {
                this.$message.error(res && res.data && res.data.message);
              }
            })
            .catch(error => {});
        });
      } else if (type === 'quit') {
        this.closeQuit();
        this.quitTeam = true;
        this.commit.teamId = row.teamId;
      } else {
        this.$confirm(`您即将要把${row.teamUser}踢出团队，是否确认？`, '请确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          closeOnClickModal: false,
          confirmButtonHighlight: true
        }).then(() => {
          this.$http
            .post(`vul/hsrc/vul/report/services/team/remove`, {
              teamUserId: row.teamUserId
            })
            .then(res => {
              // 可通过resolve发送给后端一些参数:resolve(res.data.xxx);
              if (res && res.data && res.data.status === 200) {
                this.page.currentPage = 1;
                this.$message({
                  message: `踢出该成员成功!`,
                  type: 'success'
                });
                this.getUserTeamInfo();
              } else {
                this.$message.error(res && res.data && res.data.message);
              }
            })
            .catch(error => {});
        });
      }
    },
    approve(item, val) {
      // this.query().then(res => {
      //   if (res) {
          const msg = val === 'y' ? '同意' : '拒绝';
          const paramsObj = {
            joinId: item.joinId,
            isAgree: val === 'y' ? true : false
          };
          this.$confirm(`确认是否${msg}该用户加入团队？`, '请确认', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            closeOnClickModal: false,
            confirmButtonHighlight: true
          }).then(() => {
            this.$http
              .post(`vul/hsrc/vul/report/services/team/approve`, paramsObj)
              .then(res => {
                // 可通过resolve发送给后端一些参数:resolve(res.data.xxx);
                if (res && res.status === 200 && res.data.data) {
                  this.$message({
                    message: `${msg}成功!`,
                    type: 'success'
                  });
                  this.page.currentPage = 1;
                  this.getUserTeamInfo();
                  this.getUserInfoAsync();
                } else {
                  this.$message.error(res && res.data && res.data.message);
                  this.getUserTeamInfo();
                  this.getUserInfoAsync();
                }
              })
              .catch(error => {});
          });
      //   }
      // });
    },
    approveQuit(item, val) {
      // this.query().then(res => {
      //   if (res) {
          const msg = val === 'y' ? '同意' : '拒绝';
          const paramsObj = {
            joinId: item.joinId,
            isAgree: val === 'y' ? true : false
          };
          this.$confirm(`确认是否${msg}该用户退出团队？`, '请确认', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            closeOnClickModal: false,
            confirmButtonHighlight: true
          }).then(() => {
            this.$http
              .post(`vul/hsrc/vul/report/services/team/exitTeamApproval`, paramsObj)
              .then(res => {
                if (res && res.status === 200 && res.data.data) {
                  this.$message({
                    message: `${msg}成功!`,
                    type: 'success'
                  });
                  this.page.currentPage = 1;
                  this.getUserTeamInfo();
                  this.getUserInfoAsync();
                } else {
                  this.$message.error(res && res.data && res.data.message);
                  this.getUserTeamInfo();
                  this.getUserInfoAsync();
                }
              })
              .catch(error => {});
          });
      //   }
      // });
    },
    handleSizeChange(val) {
      this.page.currentPage = 1;
      this.page.pageSize = val;
      this.getMsgList();
    },
    handleCurrentChange1(val) {
      this.page.currentPage = val;
      this.getMsgList();
    },
    getMsgList() {
      const paramsObj = {};
      this.$http
        .post(`vul/hsrc/vul/report/services/team/msg/page/${this.page.pageSize}/${this.page.currentPage}`, paramsObj)
        .then(res => {
          // 可通过resolve发送给后端一些参数:resolve(res.data.xxx);
          if (res && res.status === 200) {
            this.msgList = (res && res.data && res.data.data.result) || [];
            this.page.totalPages = (res.data && res.data.data.pageVO && res.data.data.pageVO.totalRows) || 0;
          }
        })
        .catch(error => {});
    },
    getUserTeamInfo() {
      this.msgList = [];
      this.page.pageSize = 5;
      this.page.totalPages = 0;
      this.page.currentPage = 1;
      this.latestData = [];
      this.isTeamLeader = false;
      this.$http
        .get('vul/hsrc/vul/report/services/team/mine')
        .then(res => {
          // 可通过resolve发送给后端一些参数:resolve(res.data.xxx);
          if (res && res.status === 200) {
            if (res && res.data && !res.data.data) {
              this.getMsgList();
              this.noTeam = true;
              return;
            } else {
              this.teamUserInfo = { ...res.data.data };
              if (this.teamUserInfo.avatarId) {
                this.pictureID = this.$baseURL + 'vul/hsrc/vul/report/servlet/res/image?attachmentId=' + this.teamUserInfo.avatarId;
              } else {
                this.pictureID = '';
              }
            }
            if (res && res.data && res.data.data) {
              this.isTeamLeader = res.data.data.type ? true : false;
              this.getMsgList();
              this.tableLoading = true;
              this.$http
                .get('vul/hsrc/vul/report/services/team/single')
                .then(res => {
                  // 可通过resolve发送给后端一些参数:resolve(res.data.xxx);
                  if (res.status === 200 && res.data) {
                    this.latestData = res.data.data;
                    this.tableLoading = false;
                  } else {
                    this.tableLoading = false;
                  }
                })
                .catch(error => {
                  console.log(error);
                  this.tableLoading = false;
                });
            }
          }
        })
        .catch(error => {});
    },
    refreshTable() {
      this.tableLoading = true;
      this.$http
        .get('vul/hsrc/vul/report/services/team/single')
        .then(res => {
          // 可通过resolve发送给后端一些参数:resolve(res.data.xxx);
          if (res && res.status === 200 && res.data) {
            this.latestData = res.data.data || [];
            this.tableLoading = false;
          } else {
            this.tableLoading = false;
          }
        })
        .catch(error => {
          console.log(error);
          this.tableLoading = false;
        });
    },
    dismiss() {
      this.getUserInfoAsync();
    },
    openCreateTeam() {
      // this.query().then(res => {
      //   if (res) {
          this.createTeam = true;
          this.commit.name = '';
          this.commit.headPictureUrl = '';
      //   }
      // });
    },
    openJoinTeam() {
      // this.query().then(res => {
      //   if (res) {
          this.joinTeam = true;
          this.commit.applyName = '';
          this.commit.applyMember = '';
          this.commit.applyLeader = '';
          const s = new Promise((resolve, reject) => {
            this.$http
              .get('vul/hsrc/vul/report/services/team/findTeamList')
              .then(res => {
                // 可通过resolve发送给后端一些参数:resolve(res.data.xxx);
                if (res && res.status === 200) {
                  const arr = [];
                  if (res && res.data && res.data.data.length) {
                    res.data.data.forEach(ele => {
                      arr.push({
                        label: ele.teamName,
                        value: ele.teamId,
                        userName: ele.teamUser
                      });
                    });
                  }
                  this.options1 = arr;
                } else {
                  this.$message.error(res.data && res.data.message);
                }
              })
              .catch(error => {});
          });
      //   }
      // });
    },
    handlePreview(file) {
      this.commit.headPictureUrl = `${file[0]}`;
      if (this.commit.headPictureUrl) {
        this.$refs.createTeamForm.clearValidate('headPictureUrl');
      }
    },
    changeTemplate(data) {
      if (this.options1 && this.options1.length) {
        this.options1.forEach(e => {
          if (e.value === data) {
            this.commit.applyLeader = e.userName;
          }
        });
      }
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制上传 1 个文件，如果需要重新上传，请先删除原先文件`);
    },
    reportError(err) {
      const callError = JSON.parse(err.message);
      this.$message.error(callError.message || '上传失败，请稍后再试！');
    },
    commitVerify(val) {
      if (val === 'create') {
        this.$refs.createTeamForm.validate(valid => {
          if (valid) {
            const paramsObj = {
              teamName: this.commit.name,
              avatarId: this.commit.headPictureUrl
            };
            const s = new Promise((resolve, reject) => {
              this.$http
                .post('vul/hsrc/vul/report/services/team/create', paramsObj)
                .then(res => {
                  if (res && res.data && res.data.data) {
                    this.$message({
                      message: '创建团队成功!',
                      type: 'success'
                    });
                    this.getUserTeamInfo();
                    this.createTeam = false;
                  } else {
                    this.$message.error(res.data && res.data.message);
                  }
                })
                .catch(error => {
                  console.log(error);
                });
            });
          }
        });
      } else {
        this.$refs.joinTeamForm.validate(valid => {
          if (valid) {
            const paramsObj = {
              teamId: this.commit.applyName,
              content: this.commit.applyMember
            };
            const s = new Promise((resolve, reject) => {
              this.$http
                .post('vul/hsrc/vul/report/services/team/join', paramsObj)
                .then(res => {
                  if (res && res.data && res.data.data) {
                    this.$message({
                      message: '提交成功!',
                      type: 'success'
                    });
                    this.joinTeam = false;
                    this.getUserTeamInfo();
                  } else {
                    this.$message.error(res.data && res.data.message);
                  }
                })
                .catch(error => {
                  console.log(error);
                });
            });
          }
        });
      }
    },

    handleClose: function () {
      this.$router.push({ path: '/' });
    },
    btKeyDownRealName(val, e) {
      this.commit[val] = e.target.value.replace(/[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/g, '');
    },
    // 左侧切换路由
    selectHandle: (index, indexPath) => {
      if (index === '1') {
        router.push({ path: '/usercenter/info' });
      }
      if (index === '2') {
        router.push({ path: '/usercenter/idinfo' });
      }
      if (index === '3') {
        router.push({ path: '/usercenter/report' });
      }
      if (index === '4') {
        router.push({ path: '/usercenter/sitemsg' });
      }
      if (index === '5') {
        router.push({ path: '/usercenter/teamMenu' });
      }
    },
    // 退出团队
    commitQuitOpine: function () {
      this.$refs.leaveTeamForm.validate(valid => {
        if (valid) {
          const paramsObj = {
            teamId: this.commit.teamId,
            content: this.commit.content
          };
          this.$http
            .post(`vul/hsrc/vul/report/services/team/exit`, paramsObj)
            .then(res => {
              if (res && res.status === 200) {
                this.$message.info(res.data.message);
                this.closeQuit();
                this.quitTeam = false;
              } else {
                this.$message.error('提交审核失败');
              }
            })
            .catch(error => {
              console.log(error);
            });
        }
      });
    },
    closeQuit: function () {
      this.commit.content = '';
      this.commit.teamUserId = '';
    }
  }
};
</script>
<style lang="less" scoped>
.warnning-wrap {
  /deep/.xui-dialog {
    min-width: 540px !important ;
  }
  h3 {
    text-align: center;
  }
  .content-wrap {
    padding: 60px 10px;
    ul {
      padding-left: 20px;
    }
    span a {
      text-decoration: none;
    }
  }
  .xui-button--primary {
    color: #fff;
    background-color: #409eff;
    border-color: #409eff;
    &:hover {
      background: #66b1ff !important;
      border-color: #66b1ff;
      color: #fff;
    }
  }
}

/deep/.xui-table__empty-text {
  display: none;
}
.user-setting-avatar {
  display: flex;
  justify-content: center;
  top: 0;
  font-size: 0.6rem;
  background: white center center/8rem 8rem no-repeat;
  /deep/.xui-upload-list__item-name.tooltip {
    max-width: 424px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .user-info-pic .avatar-uploader {
    position: relative;
    width: 100%;
    .upload-headPicture-btn {
      height: 1.5rem;
      line-height: 1.5rem;
      display: block;
      width: 100%;
      background-color: rgba(0, 0, 0, 0.3);
      color: #fff;
      cursor: pointer;
    }
  }

  img {
    height: 4rem;
  }
}
.user-operations {
  text-align: center;
  margin-top: 25px;
}

// 20220812界面改版需求新增
.user-center__team-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 50px;
  border-bottom: 1px solid var(--src-color-secondary-light5);
}

.user-center__team-portrait {
  display: flex;
  align-items: center;
  font-size: var(--src--text-size-large-extra1);
  color: var(--src-color-primary-dark5);
  font-weight: var(--src-text-weight-light1);
}

.user-center__team-pic {
  display: inline-block;
  width: 84px;
  height: 84px;
  border-radius: 50%;
}

.user-center__team-icon--default {
  display: inline-block;
  width: 84px;
  height: 84px;
  line-height: 84px;
  border-radius: 50%;
  font-size: var(--src--text-size-large-extra10);
  background: var(--src-bg-color-dark1);
  text-align: center;
  color: var(--src-text-color-white);
}

.user-center__team-summary-txt {
  margin-left: 20px;
}

.user-center__team-summary--right {
  &:before {
    display: inline-block;
    content: '';
    width: 1px;
    height: var(--src--text-size-large-extra1);
    margin: 0 10px;
    background-color: var(--src-color-primary-dark5);
    vertical-align: -3px;
  }
}

.user-center__team-summary-txt--inner {
  font-size: var(--src--text-size-large);
  color: var(--src-bg-color-blue-dark1);
  font-weight: var(--src-text-weight-dark1);
  max-width: calc(100vw - 869px);
  display: inline-block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  vertical-align: -4px;
}

.user-center__team-summary-txt--contributed {
  max-width: 80px;
}

.user-center__team-row--secondary {
  padding: 20px 50px;
  font-size: var(--src--text-size-medium);
  color: var(--src-color-primary-dark5);
  font-weight: var(--src-text-weight-light1);
}

.user-center__team-operation {
  display: flex;
  justify-content: flex-end;
  padding: 15px 0;
  margin: 0 50px;
  border-top: 1px solid var(--src-color-secondary-light5);
}

.user-center__team-operation-button {
  height: 30px;
  line-height: 28px;
  padding: 0 19px;
  margin-left: 10px;
  border: 1px solid #e4e4e4;
  font-size: var(--src--text-size-small);
  color: var(--src-color-primary-dark6);
  font-weight: var(--src-text-weight-light1);
  border-radius: 19px;
}

.user-center__team-list {
  padding: 0 50px;
  overflow: hidden;
}

/deep/.user-center__team-list .xui-table {
  border-right: 1px solid var(--src-color-secondary-light7);
  font-size: var(--src--text-size-default);
}

/deep/.user-center__team-list .xui-table th .cell {
  color: var(--src-color-primary-dark6);
  font-weight: var(--src-text-weight-light1);
}

/deep/.user-center__team-list .xui-table th .cell,
/deep/.user-center__team-list .xui-table td .cell {
  padding: 0 10px;
}

/deep/.user-center__team-list .xui-table th,
/deep/.user-center__team-list .xui-table td {
  border-left: 1px solid var(--src-color-secondary-light7);
  border-top: 1px solid var(--src-color-secondary-light7);
  border-bottom: none;
}

.user-center__team-pager {
  padding: 20px 50px 0;
}

.user-center__person-msg-list {
  margin: 0 50px;
  border-top: 1px solid var(--src-color-secondary-light5);
}

.user-center__person-msg-item {
  padding: 13px 0;
}

.user-center__person-msg-txt--top {
  display: flex;
  justify-content: space-between;
  font-size: var(--src--text-size-medium);
  color: var(--src-text-color-primary-light1);
  font-weight: var(--src-text-weight-light1);
}

.user-center__person-msg-tag {
  padding: 0 2px;
  border: 1px solid var(--src-bg-color-red-light2);
  font-size: var(--src--text-size-small);
  color: var(--src-bg-color-red-light2);
  transform: scale(0.8);
  border-radius: 2px;
}

.user-center__person-team-type {
  margin: 0 20px 0 10px;
}

.user-center__person-team-name {
  display: inline-block;
  max-width: 360px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: -4px;
}

@media only screen and (max-width: 1000px) {
  .user-center__person-team-name {
    max-width: 180px;
  }
}

.user-center__person-msg-txt--middle {
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  margin-top: 5px;
  font-size: var(--src--text-size-default);
  line-height: 20px;
}

.user-center__person-application {
  max-width: 38vw;
  word-break: break-word;
}

.user-center__person-msg-txt--bottom {
  margin-top: 15px;
  font-size: var(--src--text-size-small);
  color: var(--src-text-color-secondary);
}

.user-center__person-approval-button {
  margin-left: 5px;
  font-size: var(--src--text-size-default);
  color: var(--src-bg-color-blue-dark1);
  font-weight: var(--src-text-weight-light1);
  transition: all 0.3s;
  &:hover {
    opacity: 0.8;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/usercenter/teamMenu/teamMenuInfo.vue